module.exports = __webpack_public_path__ + "assets/img/teacher (57).6cc9f112.png";